import ApiService from "../service/ApiService"; // Assuming you have your API service here

const apiService = new ApiService();
// API functions
export const getdistricts = async (params) => {
  try {
    const response = await apiService.getdistricts(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching districts: " + error);
  }
};

export const getboothnumberlist = async (params) => {
  try {
    const response = await apiService.getboothnumberlist(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching booth number list: " + error);
  }
};

export const getProfessions = async (params) => {
  try {
    const response = await apiService.getProfessions(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching professions: " + error);
  }
};

export const getbloodgroups = async (params) => {
  try {
    const response = await apiService.getbloodgroups(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching blood groups: " + error);
  }
};

export const gettags = async (params) => {
  try {
    const response = await apiService.gettags(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching tags: " + error);
  }
};

export const getEmployerTypeList = async (params) => {
  try {
    const response = await apiService.getEmployerTypeList(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching employer type list: " + error);
  }
};

export const getIndustries = async (params) => {
  try {
    const response = await apiService.getIndustries(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching industries: " + error);
  }
};

export const getCompanyTypes = async (params) => {
  try {
    const response = await apiService.getcompanytypes(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching company types: " + error);
  }
};

export const getFamilyRelations = async (params) => {
  try {
    const response = await apiService.getFamilyRelations(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching company types: " + error);
  }
};

export const getClientDesignations = async (params) => {
  try {
    const response = await apiService.getclientdesignations(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getCountryCodeList = async (params) => {
  try {
    const response = await apiService.getcountrycode(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getAllTitle = async (params) => {
  try {
    const response = await apiService.getalltitle(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getEducationList = async (params) => {
  try {
    const response = await apiService.getHighestEducationList(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getCities = async (params) => {
  try {
    const response = await apiService.getcities(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getStates = async (params) => {
  try {
    const response = await apiService.getstates(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Client designations: " + error);
  }
};
export const getActiveUsers = async (params) => {
  try {
    const response = await apiService.getactiveusers(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

export const getLokSabha = async (params) => {
  try {
    const response = await apiService.getloksabha(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

export const getVidhansabha = async (params) => {
  try {
    const response = await apiService.getvidhansabha(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

export const getModules = async (params) => {
  try {
    const response = await apiService.getModules(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

export const getCallbackNumbers = async (params) => {
  try {
    const response = await apiService.getcallbacknumbers(params);
    response.data = response.records;
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

export const getDesignationSets = async (params) => {
  try {
    const response = await apiService.getDesignationSetsList(params);
    return response;
  } catch (error) {
    throw new Error("Error fetching Active users: " + error);
  }
};

// Consolidated function to call all
